// extracted by mini-css-extract-plugin
module.exports = {"ProfileBannerPlaceholder":"styles_ProfileBannerPlaceholder__2BPrR"};